"use client";
import { jsxs as a, jsx as l } from "react/jsx-runtime";
const r = ({
  title: i,
  titleId: d,
  desc: e,
  descId: f,
  ...c
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gy",
    viewBox: "0 0 640 480",
    "aria-labelledby": d,
    "aria-describedby": f,
    ...c,
    children: [
      e ? /* @__PURE__ */ l("desc", { id: f, children: e }) : null,
      i ? /* @__PURE__ */ l("title", { id: d, children: i }) : null,
      /* @__PURE__ */ a("g", { fillRule: "evenodd", children: [
        /* @__PURE__ */ l("path", { fill: "#399408", d: "M2.4 0H640v480H2.4z" }),
        /* @__PURE__ */ l("path", { fill: "#fff", d: "M.2 0c-.9 0 619.6 241.5 619.6 241.5L0 479.8z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#ffde08",
            d: "M.3 20.2c3.4 0 559 217.9 555.9 220L1.9 463.2.3 20.3z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#000001", d: "M1.9.8c1.8 0 290.9 240.9 290.9 240.9L1.8 477z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#de2110",
            d: "M.3 33.9c1.6-15 260.9 208.4 260.9 208.4L.2 451.7V33.9z"
          }
        )
      ] })
    ]
  }
);
export {
  r as default
};
